import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Store
import { GoPaperLessActions, GoPaperLessSelectors } from '@amfam/policy/go-paperless/data-access';
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';
import { GoPaperlessComponentDirective } from '../shared';

@Component({
  selector: 'app-go-paperless-signature',
  templateUrl: './go-paperless-signature.component.html',
  standalone: false
})
export class GoPaperlessSignatureComponent
  extends GoPaperlessComponentDirective
  implements OnInit, OnDestroy
{
  // Shared subject for completing observables
  private done$: Subject<void> = new Subject<void>();
  public hasError = false;

  constructor(
    private pageTitle: PageTitleService,
    private route: ActivatedRoute,
    public spinner: LoadingSpinnerService,
    store: Store<fromRoot.RootState>,
    analyticsFacade: AnalyticsFacade
  ) {
    super(store, analyticsFacade);
    this.spinner.start();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageTitle.set('Go Paperless Signature Confirmation');

    this.route.queryParams.pipe(takeUntil(this.done$)).subscribe(params => {
      if (params['event'] === 'OnSigningComplete') {
        this.enroll();
      } else {
        this.cancel();
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    this.done$.next();
    this.done$.complete();
  }

  enroll() {
    this.store.dispatch(GoPaperLessActions.EnrollGoPaperless());
    combineLatest(
      this.store.select(GoPaperLessSelectors.selectGoPaperlessLoading),
      this.store.select(GoPaperLessSelectors.selectGoPaperlessError),
      (loading, hasError) => {
        return {
          loading: loading,
          hasError: hasError
        };
      }
    )
      .pipe(takeUntil(this.done$))
      .subscribe(state => {
        if (state.hasError) {
          this.analyticsFacade.trackPageAndError(this.errorAnalytic, 'EnrollError');
          this.hasError = true;
        } else {
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['/policies/gopaperless/confirmation']
            })
          );
        }
      });
  }

  cancel() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/policies/gopaperless/enroll']
      })
    );
  }
}
